import React from 'react'
import { formatCustomerCardIssuerCountry } from '@@partner:helpers/formatters/card_type'

import { Tag } from 'rsuite'

export interface CustomerCardCountryLabelProps {
  country: string
}

export default function CustomerCardCountryLabel ({
  country
}: CustomerCardCountryLabelProps) {
  const { label, color = null } = formatCustomerCardIssuerCountry(country)

  if (country === 'Unknown' || !label) {
    return null
  }
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
